module.exports = __webpack_public_path__ + "static/media/liveness-error.3e495da5.svg";